import { Constants } from '../_constants/shared.constants';
const initialState = {};
function addProfileReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.addProfile.ADD_PROFILE:
            return {
                data: action.data,
            };
        default:
            return state
    }
}
export default addProfileReducer;